const id_mitra_list = {
    "": "Daftar Mitra",

    product: {
        btn_share: 'bagikan',
        btn_hide: 'sembunyikan',
        btn_share_all: 'bagikan semua',
        btn_hide_all: 'sembunyikan semua',
        search: 'Cari Nama Barang / SKU',
        look: 'Lihat Barang Mitra',
        look_share: 'lihat barang yang dibagikan ( {{count}} )',
    },

    tag: {
        add: 'tambah tag',
        edit: 'ubah mitra tag',
        name: 'nama tag',
    },

    error: {
        tag: 'Tag wajib diisi',
        create_tag: 'Gagal membuat tag',
        create_own_product_share: 'Gagal membagikan barang',
        create_own_product_hide: 'Gagal menyembunyikan barang',
    },

    success: {
        create_tag: 'Berhasil membuat tag',
        create_own_product_share: 'Berhasil membagikan barang',
        create_own_product_hide: 'Berhasil menyembunyikan barang',
    },
}

export default id_mitra_list;